import {
    AnalyticsEvent,
    EVENT_UAEVENT,
    GTMEventData,
} from "@hermes/utils/analytics";

import {
    EDITO_PAGE,
    GRID_PAGE,
    SINGLE_PRODUCT_PAGE,
} from "../constants/vto.constant";

import { VtoPageViewAnalyticsEventData } from "./vto-page-view.event";

/**
 * Class for VTO Button click event
 */
export class VtoButtonClickAnalyticsEvent
    implements AnalyticsEvent<GTMEventData>
{
    public name: string = EVENT_UAEVENT;
    public eventData: VtoPageViewAnalyticsEventData;

    constructor(data: VtoPageViewAnalyticsEventData) {
        this.eventData = data;
    }

    public formatForGTM(): GTMEventData {
        const pageType = this.eventData.pagetype;
        const eventLabel = this.eventData.eventLabel;
        const data: GTMEventData = {
            event: this.name,
            eventcategory:
                {
                    [SINGLE_PRODUCT_PAGE]: "SingleProductPage",
                    [GRID_PAGE]: "Product_Grid",
                    [EDITO_PAGE]: "EditoPage",
                }[pageType] || "",
            eventaction: "TryThisShade",
        };

        if (pageType === EDITO_PAGE) {
            data.eventlabel = eventLabel ?? "Try_Now";
        }

        return data;
    }
}
